// src/modules/app-views/crm/pages/Boards/modals/BoardSettingsModal/tabs/CalendarTab.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Col, Row, Switch, TimePicker } from 'antd';
import dayjs from 'dayjs';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************
const DAYS = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
const TIME_FORMAT = 'HH:mm';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const CalendarTab = ({ businessHours, setBusinessHours }) => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 6. HANDLERS
  // ─────────────────────────────────────────────────────────────────────────────
  const handleToggle = (day, enabled) => {
    setBusinessHours(prev => ({
      ...prev,
      [day]: { ...prev[day], enabled },
    }));
  };

  const handleTimeChange = (day, times) => {
    setBusinessHours(prev => ({
      ...prev,
      [day]: {
        ...prev[day],
        open: times?.[0]?.format(TIME_FORMAT) || null,
        close: times?.[1]?.format(TIME_FORMAT) || null,
      },
    }));
  };

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <div className="mt-3">
      {DAYS.map(day => {
        const config = businessHours[day] || { enabled: false, open: null, close: null };
        const timeValue =
          config.open && config.close
            ? [dayjs(config.open, TIME_FORMAT), dayjs(config.close, TIME_FORMAT)]
            : null;

        return (
          <Row key={day} align="middle" gutter={12} style={{ marginBottom: 14 }}>
            <Col flex="40px">
              <Switch
                size="small"
                checked={config.enabled}
                onChange={enabled => handleToggle(day, enabled)}
              />
            </Col>
            <Col
              flex="110px"
              style={{
                fontWeight: config.enabled ? 600 : 400,
                color: config.enabled ? undefined : 'rgba(0,0,0,0.35)',
                fontSize: 13,
              }}
            >
              {translateX(day)}
            </Col>
            <Col flex="1">
              {config.enabled ? (
                <TimePicker.RangePicker
                  format={TIME_FORMAT}
                  value={timeValue}
                  minuteStep={15}
                  onChange={times => handleTimeChange(day, times)}
                  style={{ width: '100%' }}
                />
              ) : (
                <span style={{ color: 'rgba(0,0,0,0.35)', fontSize: 13 }}>
                  {translateX('closed')}
                </span>
              )}
            </Col>
          </Row>
        );
      })}
    </div>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CalendarTab;
